import React from 'react'
import { render as ReactRender } from 'react-dom'

const __DEV__ = true

import createStore from './store/createStore'
import AppContainer from './Containers/AppContainer'

const insuranceElement = document.getElementById('insurance')
const insurance = insuranceElement.value
insuranceElement.parentNode.removeChild(insuranceElement)

const projectElement = document.getElementById('project')
const project = projectElement.value
projectElement.parentNode.removeChild(projectElement)

const basenameElement = document.getElementById('basename')
const basename = basenameElement.value
basenameElement.parentNode.removeChild(basenameElement)

const websiteElement = document.getElementById('website')
const website = websiteElement.value
websiteElement.parentNode.removeChild(websiteElement)

// ========================================================
// Store Instantiation
// ========================================================
const initialState = window.___INITIAL_STATE__ || {}
const store = createStore(initialState)

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('app')

let render = () => {
	ReactRender(
    <AppContainer basename={basename} insurance={parseInt(insurance, 10)} project={project} store={store} website={website} />,
    MOUNT_NODE
  )
}

// ========================================================
// Go!
// ========================================================
render()
